// services/UserService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated, avec les rôles de chaque utilisateur)
// params peut inclure : page, limit, search, role, is_active, with_trashed
export function getUsers(params = {}) {
    return api.get(ENDPOINTS.USERS.BASE, { params });
}

// GET ONE
export function getUserById(id) {
    return api.get(ENDPOINTS.USERS.BY_ID(id));
}

// CREATE
export function createUser(payload) {
    return api.post(ENDPOINTS.USERS.BASE, payload);
}

// UPDATE
export function updateUser(id, payload) {
    return api.patch(ENDPOINTS.USERS.BY_ID(id), payload);
}

// DELETE (désactivation - soft delete)
export function deleteUser(id) {
    return api.delete(ENDPOINTS.USERS.BY_ID(id));
}

// RESTORE
export function restoreUser(id) {
    return api.post(`${ENDPOINTS.USERS.BY_ID(id)}/restore`);
}

// ASSIGNER UN RÔLE
export function assignRoleToUser(userId, roleId) {
    return api.post(`${ENDPOINTS.USERS.BY_ID(userId)}/roles`, { role_id: roleId });
}

// RETIRER UN RÔLE
export function removeRoleFromUser(userId, roleId) {
    return api.delete(`${ENDPOINTS.USERS.BY_ID(userId)}/roles/${roleId}`);
}

// PHOTO DE PROFIL - utilisateur connecté (admin, enseignant, étudiant...)
export function uploadMyAvatar(file) {
    const formData = new FormData();
    formData.append("avatar", file);
    return api.post(`${ENDPOINTS.USERS.BASE}/me/avatar`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

// PHOTO DE PROFIL - pour un autre utilisateur (admin/staff habilité)
export function uploadUserAvatar(userId, file) {
    const formData = new FormData();
    formData.append("avatar", file);
    return api.post(`${ENDPOINTS.USERS.BY_ID(userId)}/avatar`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}
